/* Gentle autoplay for the "Shop by Craft" collection slider (and any other slider-component
   marked data-autoplay="true"). Reuses Dawn's own slider-button--next click handling rather than
   reimplementing scroll math, so it stays consistent with manual arrow clicks. Loops back to the
   start once the next button reports disabled (end of track). Pauses permanently on any user
   interaction with the slider, and never runs for reduced-motion users. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var wired = new WeakSet();

  function wire(slider) {
    if (reduceMotion || wired.has(slider)) return;
    var track = slider.querySelector('ul.slider');
    var nextButton = slider.querySelector('.slider-button--next');
    if (!track || !nextButton) return;
    wired.add(slider);

    var autoplayId = null;

    function stop() {
      if (autoplayId) {
        clearInterval(autoplayId);
        autoplayId = null;
      }
    }

    function start() {
      if (autoplayId) return;
      autoplayId = setInterval(function () {
        if (nextButton.disabled) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          nextButton.click();
        }
      }, 3500);
    }

    ['pointerdown', 'wheel', 'touchstart'].forEach(function (evt) {
      track.addEventListener(evt, stop, { passive: true });
    });
    slider.querySelectorAll('.slider-button').forEach(function (btn) {
      btn.addEventListener('click', stop);
    });

    start();
  }

  function scan() {
    document.querySelectorAll('slider-component[data-autoplay="true"]').forEach(wire);
  }

  scan();
  var observer = new MutationObserver(scan);
  observer.observe(document.body, { childList: true, subtree: true });
})();
